import React, { useEffect, useState } from 'react';
import { Input, showErrorSnackbar } from '@doopage/react-ui-kit';
import { t } from '@lingui/macro';
import Separator from '../../../component/Separator';
import Button from '../../../MUI_Kit/components/CustomButtons/Button';
import IconButton from '@material-ui/core/IconButton/IconButton';
import { useHistory } from 'react-router-dom';
import { useApi } from '../../../hook/utils';
import {loginByPassword, loginByPassword2} from '../../../api/api';
import DV from '../../../variables/DV';
import LocalStorage from '../../../config/LocalStorage';
import Routes from '../../../router/routes';
import {default as decodeJWT} from "jwt-decode";

const LoginByPasswordForm = ({ onSuccess, loading, setLoading }) => {
  const history = useHistory();
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');

  const { doFetch, error } = useApi();

  const onKeyPress = (e) => {
    if (e.keyCode == 13) {
      onSubmit();
    }
  };

  useEffect(() => {
    if (error) {
      setLoading(false);
      showErrorSnackbar(error);
    }
  }, [error]);

  const onSubmit = async () => {
    if (username?.length < 3 || password?.length < 3) {
      showErrorSnackbar(t`Tên đăng nhập hoặc mật khẩu không hợp lệ`);
      return;
    }
    setLoading(true);
    const { data } = await doFetch(loginByPassword2({ username, password }));
    if (data?.access) {
      let { access, refresh } = data;
      DV.token = access;
      const decodedToken = decodeJWT(access)
      DV.tokenExpireTime = new Date().getTime() + (decodedToken.exp - decodedToken.iat)*1000
      const decodedRefreshToken = decodeJWT(refresh);
      DV.refreshTokenExpireTime = new Date().getTime() + (decodedRefreshToken.exp - decodedRefreshToken.iat)*1000
      await LocalStorage.setToken(access);
      await LocalStorage.setToLocal('refreshToken',   DV.tokenExpireTime)
      await LocalStorage.setToLocal('tokenExpireTime',   DV.tokenExpireTime)
      await LocalStorage.setToLocal('refreshTokenExpireTime',  DV.refreshTokenExpireTime)
      window.location.href = window.location.origin;
    }
  };
  return (
    <div className={'flex flex-col w-full'}>
      <Input
        disabled={loading}
        id={'username'}
        label={t`Tên đăng nhập`}
        value={username}
        onChange={(e) => setUsername(e?.target?.value)}
      />
      <Separator height={15} />
      <Input
        disabled={loading}
        id={'password'}
        type={'password'}
        label={t`Mật khẩu`}
        value={password}
        onChange={(e) => setPassword(e?.target?.value)}
        onKeyDown={onKeyPress}
      />
      <Separator height={15} />
      <div className={'flex flex-row'}>
        <div className="flex-1">
          <IconButton
            aria-label="Toggle password visibility"
            onClick={() => history.replace(Routes.login.path)}>
            <i className="fas fa-arrow-left" />
          </IconButton>
        </div>
        <div className="flex-1">
          <Button color="info" loading={loading} onClick={onSubmit}>
            {t`ĐĂNG NHẬP`}
          </Button>
        </div>
        <div className="flex-1"></div>
      </div>
    </div>
  );
};

export default LoginByPasswordForm;
